import { cn } from '../utils/css/cn';

interface LoadingBouncerProps {
	className?: string;
}

export const LoadingBouncer = (props: LoadingBouncerProps) => {
	const { className = 'h-5' } = props;

	return <div className={cn('loading-bouncer', className)}></div>;
};

export default LoadingBouncer;
